import type { NodeDefinition } from '../types';

export const numberInputNode: NodeDefinition = {
  type: 'input.number',
  category: 'Input',
  label: 'Number Value',
  description: 'Outputs a constant numeric floating-point scalar',
  inputs: [],
  outputs: [
    { id: 'number', name: 'Number', type: 'number', defaultValue: 1.0 },
  ],
  params: [
    { id: 'value', name: 'Value', type: 'number', defaultValue: 1.0, step: 0.1 },
  ],
  processor: (_inputs, params) => {
    const val = Number(params.value ?? 1.0);
    return { number: isNaN(val) ? 0 : val };
  },
};
